import type { PriceId } from './product';

export const TerpeneEnumValues = [
  'limonene',
  'nerolidol',
  'valencene',
  'caryophyllene',
  'caryophyllene oxide',
  'sabinene',
  'linalool',
  'geraniol',
  'geranyl acetate',
  'humulene',
  'myrcene',
  'pinene',
  'camphene',
  'camphor',
  'carene',
  'cedrene',
  'guaiol',
  'eucalyptol',
  'terpineol',
  'terpinolene',
  'phellandrene',
  'bisabolol',
  'borneol',
  'cymene',
  'fenchol',
  'menthol',
  'isoborneol',
  'isopulegol',
  'pulegone',
  'ocimene',
  'phytol',
] as const;
export type TerpeneEnum = (typeof TerpeneEnumValues)[number];

interface LabResult {
  compound_name: string;
  unit: string;
  unit_id: string;
  value: number;
}

export interface LabResultWithTerpene extends LabResult {
  matchingTerpene: TerpeneEnum;
}

export interface WeightedLabResult {
  lab_results: LabResult[];
  price_id: PriceId;
}

export type TerpeneFlavorEnum =
  | 'citrusy'
  | 'spicy'
  | 'floral'
  | 'hoppy'
  | 'earthy'
  | 'herbal';
